<template>
  <div :class="{ 'admin-editing-arrow': isEditingArrow }">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const isEditingArrow = ref(false)

// Scrollt die Seite nach oben - wird beim initialen Laden und Reload verwendet
const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, behavior: 'instant' })
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }
}

// Handler für pageshow Event (wird beim Reload ausgelöst, auch aus dem Cache)
const handlePageShow = (event: PageTransitionEvent) => {
  // Wenn die Seite aus dem Cache geladen wurde (z.B. beim Zurück-Navigieren)
  // oder beim normalen Reload, scroll nach oben
  if (event.persisted || !event.persisted) {
    // Kleine Verzögerung, um sicherzustellen, dass das DOM bereit ist
    setTimeout(() => {
      scrollToTop()
    }, 0)
  }
}

// Wir müssen den State globaler verwalten oder über ein Event/Bus
// Für dieses Beispiel nutzen wir ein einfaches Event
onMounted(() => {
  // Stelle sicher, dass die Seite beim initialen Laden oben startet
  scrollToTop()
  
  // Zusätzlich nach nextTick, um sicherzustellen, dass das DOM vollständig gerendert ist
  setTimeout(() => {
    scrollToTop()
  }, 0)
  
  window.addEventListener('arrow-edit-mode', ((e: CustomEvent) => {
    isEditingArrow.value = e.detail.active
  }) as EventListener)
  
  // Listener für pageshow hinzufügen (wird beim Reload ausgelöst)
  window.addEventListener('pageshow', handlePageShow)
})

onUnmounted(() => {
  window.removeEventListener('pageshow', handlePageShow)
})
</script>

<style>
.admin-editing-arrow, .admin-editing-arrow * {
  cursor: auto !important;
}
</style>

